import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { userType } from 'app/helpers/userType';
import { useSelector } from 'react-redux';

function PrivateRoute({ children, permission }) {
  const token = useSelector((state) => state?.auth?.token);
  const { isMA } = userType();

  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (!token) {
      if (pathname !== requestedLocation) {
        setRequestedLocation(pathname);
      }
      return; // No need to continue rendering
    }
    if (isMA) {
      setLoader(true);
    } else {
      if (permission) {
        if (Array.isArray(JSON.parse(localStorage.getItem('permission')))) {
          const hasPermission = JSON.parse(
            localStorage.getItem('permission'),
          ).some((num) => num?.name === permission);
          setLoader(hasPermission);
        } else {
          setLoader(false);
        }
      } else {
        setLoader(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    permission,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.parse(localStorage.getItem('permission')),
    pathname,
    requestedLocation,
    token,
  ]);

  if (!token) {
    return <Navigate to="/login" />;
  }
  if (!loader) {
    return <Navigate to="/401" />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return children;
}

PrivateRoute.propTypes = {
  children: PropTypes.node,
};

export default PrivateRoute;
